// src/app/app.routes.ts

import { Routes } from '@angular/router';
import { authenticationGuard, authorizationGuard, ErrorComponent, WhoamiComponent } from 'shared-frontend';
import { PERMISSION_SETS } from './core/roles.constants';
import { NEWSLETTER_HEADER_PATHS } from './core/app.paths';

const loadNewsletterHeaderRoutes = () => import('./features/newsletter-header.routes').then(m => m.NEWSLETTER_HEADER_ROUTES);
const loadRecipientRoutes = () => import('./features/recipient.routes').then(m => m.RECIPIENT_ROUTES);

export const routes: Routes = [
    {
        path: '',
        canActivate: [authenticationGuard], // ← Everything requires authentication
        children: [
            { path: 'whoami', component: WhoamiComponent },
            { path: '', redirectTo: NEWSLETTER_HEADER_PATHS.create, pathMatch: 'full' }, // Default
            { path: '', loadChildren: loadNewsletterHeaderRoutes },
            { path: '', loadChildren: loadRecipientRoutes },
        ]
    }
];
